import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'smartCapitalize'})
export class SmartCapitalizePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value;
    
    // If all uppercase, convert to title case
    if (value === value.toUpperCase()) {
      return value.toLowerCase().replace(/\b\w/g, l => l.toUpperCase());
    }
    
    // Otherwise, just capitalize first letter
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
  }
}